<template>
  <el-col style="text-align: center; overflow-y: scroll;padding-bottom: 100px;" class="content">
    <el-col style="width: 96%;margin-left: 2%; background-color: yellowgreen; font-family:'Microsoft YaHei'; text-align: left;">
      <el-col class="cell_room">
        <p class="cell_title">Leading Institutions</p>
        <p class="cell_item">· State Key Laboratory of Earth Surface Processes and Resource Ecology, Beijing Normal University (BNU)</p>
        <p class="cell_item">· Key Laboratory of Environmental Change and Natural Disaster, Ministry of Education of China, BNU</p>
        <p class="cell_item">· Academy of Disaster Reduction and Emergency Management, Ministry of Emergency Management (MEM) and Ministry of Education (MOE)</p>
        <p class="cell_item">· Faculty of Geographical Science, BNU</p>
      </el-col>
    </el-col>

    <el-col style="width: 96%;margin-left: 2%;margin-top: 2%; background-color: yellowgreen; font-family:'Microsoft YaHei'; text-align: left;">
      <el-col class="cell_room">
        <p class="cell_title">Participating Institutions</p>
        <p class="cell_item">· Institute of Atmospheric Physics, Chinese Academy of Science (CAS), China</p>
        <p class="cell_item">· Institute of Geographical Sciences and Natural Resources Research, CAS, China</p>
        <p class="cell_item">· Cold and Arid Regions Environmental and Engineering Research Institute, CAS, China</p>
        <p class="cell_item">· National Disaster Reduction Center of China, MEM, China</p>
      </el-col>
    </el-col>


    <el-col style="width: 96%;margin-left: 2%;margin-top: 2%; background-color: yellowgreen; font-family:'Microsoft YaHei'; text-align: left;">
      <el-col class="cell_room">
        <p class="cell_title">Data Sources</p>
        <p class="cell_item">· Food and Agriculture Organization (FAO), UN</p>
        <p class="cell_item">· International Institute for Applied Systems Analysis (IIASA), Austria</p>
        <p class="cell_item">· United States Geological Survey (USGS), USA</p>
        <p class="cell_item">· National Aeronautics and Space Administration (NASA), USA</p>
        <p class="cell_item">· The International Disaster Database Centre for Research on the Epidemiology of Disasters, CRED (EM-DAT), Belgium</p>
      </el-col>
    </el-col>


  </el-col>
</template>

<script>
export default {
  name: "SupportingInstitutions"
}
</script>

<style scoped>

.cell_room{
  padding: 20px;
  box-shadow: 5px 5px 5px rgba(0,0,0,0.05);
  border: solid 1px rgba(240,240,240,1);
  background-color: white;;
}

.cell_title{
  font-size: 26px;
  color: #324157;
  letter-spacing: 0;
}

.cell_item{
  font-size: 15px;
  color: #8A8A8A;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
}

.content{
  text-align: left;
  padding-top: 5vh;
}

.content::-webkit-scrollbar {
  display: none;/*隐藏滚动条*/
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/SupportingInstitutions.vue